export default {"header":"zD2tha_header","path":"zD2tha_path","endpoint":"zD2tha_endpoint","heading":"zD2tha_heading","group":"zD2tha_group",}